import React from 'react';

// Empty state component for when no data is available
const EmptyState = ({ message = '暂无数据', subMessage = '请添加数据以查看表格' }) => {
  return (
    <div
      className="flex flex-col items-center justify-center py-8 border border-dashed border-gray-300 rounded"
    >
      <h6 className="text-lg font-medium text-muted-foreground mb-1">
        {message}
      </h6>
      <p className="text-sm text-muted-foreground">
        {subMessage}
      </p>
    </div>
  );
};

export default EmptyState;
